const editor = {
  toolbar: 'Panel nástrojů',
  content_area: 'Hlavní oblast editoru, začněte psát.',
  back: 'Zpět',
  undo: 'Zpět',
  redo: 'Znovu',
  heading: 'Nadpis',
  heading_format: 'Formátovat text jako nadpis',
  heading_level: 'Nadpis {{level}}',
  list: 'Seznam',
  list_options: 'Možnosti seznamu',
  bullet_list: 'Odrážkový seznam',
  ordered_list: 'Číslovaný seznam',
  task_list: 'Seznam úkolů',
  blockquote: 'Citace',
  code_block: 'Blok kódu',
  bold: 'Tučné',
  italic: 'Kurzíva',
  strike: 'Přeškrtnuté',
  code: 'Kód',
  underline: 'Podtržené',
  text_color: 'Barva textu',
  text_color_palette: 'Paleta barev textu',
  text_color_value: 'Barva textu: {{color}}',
  text_color_default: 'Výchozí barva textu',
  text_color_custom: 'Vlastní barva textu',
  text_color_black: 'Černá',
  text_color_gray: 'Šedá',
  text_color_red: 'Červená',
  text_color_blue: 'Modrá',
  text_color_green: 'Zelená',
  text_color_orange: 'Oranžová',
  superscript: 'Horní index',
  subscript: 'Dolní index',
  align_left: 'Zarovnat vlevo',
  align_center: 'Zarovnat na střed',
  align_right: 'Zarovnat vpravo',
  align_justify: 'Zarovnat do bloku',
  highlight: 'Zvýraznění',
  highlight_text: 'Zvýraznit text',
  highlight_colors: 'Barvy zvýraznění',
  highlight_color: 'Barva zvýraznění: {{color}}',
  remove_highlight: 'Odstranit zvýraznění',
  color_default: 'Výchozí pozadí',
  color_gray: 'Šedé pozadí',
  color_brown: 'Hnědé pozadí',
  color_orange: 'Oranžové pozadí',
  color_yellow: 'Žluté pozadí',
  color_green: 'Zelené pozadí',
  color_blue: 'Modré pozadí',
  color_purple: 'Fialové pozadí',
  color_pink: 'Růžové pozadí',
  color_red: 'Červené pozadí',
  link: 'Odkaz',
  link_placeholder: 'Vložte odkaz...',
  link_apply: 'Použít odkaz',
  link_open: 'Otevřít v novém okně',
  link_remove: 'Odstranit odkaz',
  search_replace: 'Najít a nahradit',
  previous_result: 'Předchozí výsledek',
  next_result: 'Další výsledek',
  close: 'Zavřít',
  search: 'Najít',
  replace: 'Nahradit',
  replace_all: 'Nahradit vše',
  replace_current_result: 'Nahradit aktuální výsledek',
  replace_all_results: 'Nahradit všechny výsledky',
  match_case: 'Rozlišovat velikost písmen',
  whole_words: 'Pouze celá slova',
  use_regex: 'Použít regulární výraz',
  try_search_pattern: 'Vyzkoušejte vyhledávací vzor',
  regex_any_middle_letter: 'Libovolné písmeno uprostřed:',
  regex_either_term: 'Jeden z výrazů:',
  regex_case_c: 'Velké nebo malé C:',
  try_search_replace: 'Vyzkoušejte najít a nahradit',
  replace_with: 'na',
  regex_docs: 'Další informace o regulárních výrazech',
}

export default editor
